import isEqual from 'lodash/isEqual';

export const filterUnequalValues = (
  sourceData: any[],
  firstFieldName: string,
  secondFieldName: string,
): any[] => {
  if (!sourceData?.length || !firstFieldName || !secondFieldName) {
    return [];
  }

  const filteredItems = sourceData?.filter((data) => {
    return !isEqual(data?.[firstFieldName], data?.[secondFieldName]);
  });
  return filteredItems;
};

export const includesAnyWord = (str, wordArray) => {
  return wordArray?.some((word) => str.includes(word));
};

export const filterDuplicatesByKeys = (list: any[], filterKeys: string[]) => {
  const filteredSet = new Set();

  return list?.filter((item) => {
    // Create a composite key by joining values of all specified keys
    const compositeKey = filterKeys
      .map((key) => JSON.stringify(item?.[key]))
      .join('|');

    if (filteredSet?.has(compositeKey)) {
      return false; // Skip this item (duplicate across all specified keys)
    } else {
      filteredSet.add(compositeKey); // Add composite key to set of seen values
      return true;
    }
  });
};

export const replaceUnderScore = (text: string) => {
  return text?.replace(/_/g, ' ') || '';
};
